export default "__VITE_ASSET__BVdL6AMd__"